/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailShipsFrom_item = {
    readonly address: {
        readonly itemAddress: string | null;
    } | null;
    readonly " $refType": "PdpSharedDetailShipsFrom_item";
};
export type PdpSharedDetailShipsFrom_item$data = PdpSharedDetailShipsFrom_item;
export type PdpSharedDetailShipsFrom_item$key = {
    readonly " $data"?: PdpSharedDetailShipsFrom_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailShipsFrom_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedDetailShipsFrom_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "address",
      "storageKey": null,
      "args": null,
      "concreteType": "Address",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": "itemAddress",
          "name": "displayCityStateCountry",
          "args": [
            {
              "kind": "Literal",
              "name": "fullCountryName",
              "value": true
            }
          ],
          "storageKey": "displayCityStateCountry(fullCountryName:true)"
        }
      ]
    }
  ]
};
(node as any).hash = 'a30dcf2c93a14e834f0b5af680f91c0c';
export default node;
